<template>
<div class="play-guide">
    <div class="scroll-wrapper">
        <cube-scroll ref="scroll"
                    :data="guideArray"
                    direction="horizontal"
                    class="tab-scroll">
            <div class="guide-tabs" ref="list">
                <div :id="item.id"
                     ref="tab"
                    class="tab"
                    :class="{'active': activeIndex === index}"
                    v-for="(item, index) in guideArray"
                    :key="index"
                    @click="handleChangeTab(index)">
                    <div class="tab-text">{{ item.text }}</div>
                </div>
            </div>
        </cube-scroll>
    </div>
    <div class="guide-content">
        <div class="content"
             v-for="(item, index) in guideArray"
             :key="`content-${index}`"
             :id="`${item.id}-text`">
            <div class="title">{{ item.text }}</div>
            <!-- <rich-text wx:if="{{ type === 'site' }}" class="text" nodes="{{ guide.description }}"></rich-text> -->
            <a v-if="item.id === 'number'" class="text phone" :href="`tel:${item.content}`">{{ item.content }}</a>
            <div class="text" v-else>{{ item.content }}</div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    data () {
        return {
            activeIndex: 0,
            guideArray: []
        }
    },
    created () {
        this.guideArray = this.$store.state.guideArray
        this.$nextTick(() => {
            this.hanldeElements()
        })
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        // 计算所有节点的高度
        hanldeElements () {
            this.guideArray.forEach(item => {
                // document.querySelector(`#${item.id}-text`).offsetTop - 40
                item.top = document.querySelector(`#${item.id}-text`).offsetTop - 40
            })
        },
        handleChangeTab (index) {
            this.activeIndex = index
            window.scrollTo(0, this.guideArray[index].top)
        },
        handleScroll (e) {
            const scrollTop = window.scrollY
            console.log(screenTop)
            let currentTab = null
            for (let i = 0; i < this.guideArray.length - 1; i++) {
                if (scrollTop >= this.guideArray[i].top - this.guideArray[0].top && scrollTop < this.guideArray[i + 1].top + this.guideArray[0].top) {
                    currentTab = i
                }
            }
            this.activeIndex = currentTab
            let left = this.$refs.tab[currentTab].offsetLeft
            const currentWidth = this.$refs.tab[currentTab].clientWidth
            const totalLength = this.$refs.list.clientWidth
            if (left <= 12) {
                left = 0
            } else if (left >= totalLength - window.innerWidth + 12) {
                left = totalLength - window.innerWidth + 12
            } else {
                left -= 10
            }
            console.log(left, currentWidth, totalLength)
            this.$refs.scroll.scrollTo(-left, 0, 500, 'ease-in-out')
        }
    }
}
</script>

<style lang="scss" scoped>
/* packageScenic/pages/playGuide/index.wxss */
.scroll-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    height: 40Px;
    box-shadow: 0 2px 4px 0 rgba(34, 33, 37, 0.3);
}

.guide-tabs {
    white-space: nowrap;
}

.guide-tabs .tab {
    padding: 12Px 12Px 12Px;
    font-size: 16Px;
    color: #222125;
    position: relative;
    flex-shrink: 0;
    display: inline-block;
}

.guide-tabs .tab-text {
    position: relative;
    z-index: 1;
    line-height: 1em;
}

.guide-tabs .tab:after {
    content: '';
    width: 64px;
    height: 4px;
    background-color: #f8a909;
    position: absolute;
    bottom: 12px;
    left: 50%;
    margin-left: -32px;
    transform: scale(0);
    transition: transform 0.2s ease-out;
    z-index: 0;
}

.guide-tabs .tab.active {
    font-weight: bold;
    font-family: GothamBold;
}

.guide-tabs .tab.active:after {
    transform: scale(1);
}

.guide-content {
    padding: 40px 12px 20px;
}

.guide-content .content {
    padding-top: 20px;
}

.guide-content .title {
    font-size: 16px;
    color: #222125;
    font-weight: bold;
    font-family: GothamBold;
}

.guide-content .text {
    font-size: 14px;
    line-height: 1.5em;
    color: #888888;
    margin-top: 12px;
}

.guide-content .phone {
    text-decoration: underline;
}
</style>